/**
 * WssAuditPopup Component
 * Modal for HO Auditor users to enter audit details before check-in
 * Fields: Retail counter present, Non-performing WSS, Company Name (conditional)
 */

import React, { useState } from "react";
import styles from "@components/MarketWorking/MyWss/MyWssFeedbackAuditorForm.module.css";
import ModalPopup from "@components/Common/ModalPopup";
import Loader from "@features/shared/components/Loader";

const WssAuditPopup = ({ isOpen, setIsOpen, onSubmit }) => {
  const [retailCounter, setRetailCounter] = useState("");
  const [nonPerforming, setNonPerforming] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    setIsOpen(false);
  };

  const handleSubmit = () => {
    setLoading(true);
    const payload = {
      retailCounter,
      nonPerforming,
      nonPerformingCompany: nonPerforming === "Yes" ? companyName : "",
    };
    onSubmit(payload);
    setLoading(false);
  };

  const isSubmitDisabled =
    !retailCounter ||
    !nonPerforming ||
    (nonPerforming === "Yes" && !companyName);

  return (
    <ModalPopup
      isModalOpen={isOpen}
      setIsModalOpen={setIsOpen}
      ModalMainClass="myWssFeedbackForm"
      backdrop={false}
      fade={true}
      data={
        <>
          <Loader loading={loading} />
          <div>
            <div className={styles.auditPopup__title}>WSS Audit Details</div>

            <label className={styles.auditPopup__label}>Retail counter present?</label>
            <select
              className={styles.auditPopup__select}
              value={retailCounter}
              onChange={(e) => setRetailCounter(e.target.value)}
            >
              <option value="">Select...</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>

            <label className={styles.auditPopup__label}>Non-performing WSS?</label>
            <select
              className={styles.auditPopup__select}
              value={nonPerforming}
              onChange={(e) => setNonPerforming(e.target.value)}
            >
              <option value="">Select...</option>
              <option value="Yes">Yes</option>
              <option value="No">No</option>
            </select>

            {nonPerforming === "Yes" && (
              <>
                <label className={styles.auditPopup__label}>Company Name</label>
                <input
                  type="text"
                  placeholder="Enter Company Name"
                  className={styles.auditPopup__input}
                  value={companyName}
                  onChange={(e) => setCompanyName(e.target.value)}
                />
              </>
            )}

            <div className={styles.auditPopup__btnGroup}>
              <button
                className={`${styles.auditPopup__btn} ${styles.auditPopup__btnCancel}`}
                onClick={handleClose}
              >
                Cancel
              </button>
              <button
                className={`${styles.auditPopup__btn} ${styles.auditPopup__btnSubmit}`}
                onClick={handleSubmit}
                disabled={isSubmitDisabled}
              >
                Submit
              </button>
            </div>
          </div>
        </>
      }
    />
  );
};

export default WssAuditPopup;
